import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Layout = styled(FlexColumn)`
    justify-content: space-between;
    height: 100%;
    padding: 16px;
    box-sizing: border-box;
`;

export const TextContainer = styled(FlexColumn)`
    height: 50%;
    margin-top: 16px;
    overflow: hidden;
`;

export const Title = styled.p`
    margin: 0 0 5px;
    ${setFontVariant("captionTitle", colorsPalettes.carbon[300])};
`;

export const Text = styled.p`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])};

    &.hovered {
        ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    }
`;

export const FooterContainer = styled(FlexRow)`
    height: 24px;
    align-items: center;
`;

export const HoverFooterWrapper = styled(FlexRow)<{
    displayed: boolean;
}>`
    display: ${(props) => (props.displayed ? "flex" : "none")};
    width: 100%;
    justify-content: space-between;
    align-items: center;
`;

export const ArrowIconWrapper = styled.div`
    & > div {
        width: 20px;
        height: 20px;
    }

    & svg > path {
        fill: ${colorsPalettes.blue[400]};
    }
`;

export const SharedIconWrapper = styled.div`
    margin-right: 12px;
    & > div {
        width: 20px;
        height: 20px;
    }
`;

export const SharedTooltipContent = styled(FlexColumn)`
    align-items: center;
    ${setFontVariant("captionTitle", colorsPalettes.bluegrey[100])};
`;

export const AddedDate = styled.div<{
    displayed: boolean;
}>`
    display: ${(props) => (props.displayed ? "block" : "none")};
    ${setFontVariant("caption", colorsPalettes.carbon[200])};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
